import { render } from "./ModernInput.vue?vue&type=template&id=3494a84c&scoped=true"
import script from "./ModernInput.vue?vue&type=script&lang=js"
export * from "./ModernInput.vue?vue&type=script&lang=js"

import "./ModernInput.vue?vue&type=style&index=0&id=3494a84c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3494a84c"]])

export default __exports__